export default {
    APP_DOCUMENTATION_OPEN_MODAL: 'APP_DOCUMENTATION_OPEN_MODAL',
    APP_DOCUMENTATION_CLOSE_MODAL: 'APP_DOCUMENTATION_CLOSE_MODAL',
    APP_DOCUMENTATION_FETCH_DATA: 'APP_DOCUMENTATION_FETCH_DATA',
    APP_DOCUMENTATION_SPINNER_START: 'APP_DOCUMENTATION_SPINNER_START',
    APP_DOCUMENTATION_SPINNER_STOP: 'APP_DOCUMENTATION_SPINNER_STOP',
};
